<template lang="pug">
.surface
  EditableLine(v-model="profile.line", :color="[0, 1, 0, 1]")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { Profile } from '@/modules/ssp_database/ObjectProfileModule/Profile';
import { EditableLine } from "@/stellar-globe-components/Line";

@Component({
  components: { EditableLine },
})
export default class extends Vue {
  @Prop({ required: true })
  profile!: Profile
}
</script>
